import actionTypes from '../actionTypes';

export const FETCH_ASSETS = actionTypes('FETCH_ASSETS');
export const FETCH_ASSET = actionTypes('FETCH_ASSET');
export const UPDATE_ASSET = actionTypes('UPDATE_ASSET');
export const FETCH_PAYMENT_PROVIDERS = actionTypes('FETCH_PAYMENT_PROVIDERS');
